// eslint-disable-next-line
import React from "react";
// eslint-disable-next-line
import ReactDOM from "react-dom";

/*
if (process.env.NODE_ENV !== 'production') {
    const a11y = require('react-a11y').default;
    a11y(React, ReactDOM, {
        rules: {
            'button-role-space': 'error',
            'hidden-uses-tabindex': 'error',
            'img-uses-alt': 'error',
            'label-uses-for': 'error',
            'mouse-events-map-to-key-events': 'error',
            'no-access-key': 'error',
            'no-hash-ref': 'error',
            'no-unsupported-elements-use-aria': 'error',
            'onclick-uses-role': 'error',
            'onclick-uses-tabindex': 'error',
            'redundant-alt': 'error',
            'tabindex-uses-button': 'error',
            'use-onblur-not-onchange': 'error',
            'valid-aria-role': 'error',
        },
    });

    var axe = require('react-axe');
    axe(React, ReactDOM, 1000);
}
*/






// WEBPACK FOOTER //
// ./src/misc/accessibilityChecks.js